export default {
    "label.update_translations_unsuccessful": "{count}个项目失败：",
    "global.no_records": "无记录",
    "notifications.rp_has_been_updated": "金奖团体生活科目已经被更新",
    "moduleTitle.files": "文件",
    "label.coordinator": "协调员",
    "sidebar.translations_managment": "翻译管理",
    "table.file": "文件",
    "label.report_overview": "概况",
    "label.parent_agreement": "父母同意书",
    "parentalConsent.i_consent_to_and_understand_that": "6. 我理解并同意，参与者在参加奖项时所拍摄的所有照片，在参与者父母亲签署同意书后，作为宣传使用。",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "我明白参与者必须遵守在线记录手册或者记录册里包含的奖项要求，必须遵守爱丁堡公爵国际奖运营者的行为准则标准（不断修订），以及奖项单位关于急救计划，活动评估，爱丁堡公爵国际奖户外探索活动要求，同时明白如果参与者不能遵守奖项的以上要求，奖项单位有权终止参与者参加奖项活动。",
    "table.end_date": "结束日期",
    "label.activation_date": "激活日期",
    "label.report": "报告",
    "label.award_is_offline": "奖项是线下的",
    "label.pending_changes": "右下角窗格",
    "errors.min_nights_required": "最低的晚数要求",
    "label.country": "国家/地区",
    "notifications.award_leader_has_been_returned": "导师已经被退回",
    "notifications.participant_has_been_updated": "参与者已经更新",
    "label.phone_number": "电话号码",
    "roles.aj_assessor": "户外探索旅行科目评审员",
    "notifications.person_state_has_been_changed": "个人状态已经修改",
    "pageTitle.dashboard": "仪表板",
    "moduleTitle.global_payment_method": "全球支付方式",
    "label.organization_type": "组织类别",
    "button.account_settings": "帐户设置",
    "notifications.contact_has_been_updated": "联系方式已更新。",
    "participant.recover_password": "恢复密码",
    "notifications.assessment_request_has_been_sent": "审核申请已经发送",
    "button.unassign": "未分配",
    "label.start_date": "开始日期",
    "label.assign_labels": "分配标签",
    "sidebar.participants": "参与者",
    "roles.coordinator": "协调官",
    "label.organization_contact": "组织联系人",
    "tabs.customization": "定制",
    "sidebar.award_units": "奖项单位",
    "button.change_goal": "修改目标",
    "translationsManagement.selectProject": "translationsManagement.selectProject",
    "award.rp": "金奖团体生活项目",
    "label.size": "大小",
    "label.bulk_action_results": "批量操作结果",
    "notifications.activity_has_been_approved": "活动已经得到批准",
    "label.payment_type": "支付类型",
    "button.gop_assignment": "GOP分配",
    "button.resend_assessment_request": "重新发送审核要求",
    "notifications.template_has_been_removed": "模板已经被删除",
    "button.award_settings": "奖项设置",
    "pageTitle.payment": "支付",
    "tasks.return_award": "退回奖项",
    "label.link": "链接",
    "moduleTitle.award_participant_delete": "删除参与者奖项",
    "pageTitle.mro_related_contacts": "我的地区办公室－相关联系",
    "pageTitle.my_organization_labels": "我的机构-标签",
    "tabs.activity_signoff": "科目签字",
    "table.logs": "日志",
    "moduleTitle.remove_file": "删除文件",
    "label.email_confirmed": "邮箱确认",
    "notifications.activity_has_been_returned": "活动已经被退回。",
    "label.note": "备注",
    "button.show": "显示",
    "tabs.adventurous_journey": "户外探索旅行",
    "sidebar.my_todolist": "我的代办清单",
    "label.here": "这里",
    "organisation.change_award_mode": "修改奖项模式",
    "table.note_from_al": "导师的备注",
    "label.gender": "性别",
    "moduleTitle.remove": "删除？",
    "errors.must_be_less_than": "必须少于",
    "button.logout": "退出系统",
    "label.no_selected_participants": "没有选择参与者",
    "button.new_aj_event": "新的户外探索活动",
    "label.employement_status": "就业状态",
    "tabs.logs": "日志",
    "tabs.contacts": "联系",
    "label.option": "选择",
    "dashboard.charts": "表格",
    "notifications.rp_has_been_approved": "金奖团体生活科目已经被批准",
    "pageTitle.new_participant": "新的参与者",
    "notifications.award_leader_has_been_approved": "导师已经批准。",
    "moduleTitle.would_you_like_to_remove_leader_training": "您希望删除奖项项目管理员的培训吗？",
    "moduleTitle.update_configuration_value": "更新配置值",
    "table.description": "描述",
    "table.organization": "组织",
    "label.youtube": "Youtube视频网站",
    "label.author": "作者",
    "table.suitable_for_award_level": "适合奖项级别",
    "label.content_update": "请等待。更新内容中。。。",
    "notifications.new_question_has_been_added": "新问题已经增加",
    "pageTitle.nao_awards": "国家办公室－奖项",
    "table.last_name": "姓",
    "moduleTitle.adventurous_journey_detail": "旅程详情",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "批量操作"},
    "label.project_location_type": "项目地址类型",
    "label.email_help_award_level": "奖项级别",
    "label.date": "日期",
    "label.previous_completed_award_place": "哪里",
    "button.show_more": "显示更多",
    "label.wwc_number": "WWC 号",
    "button.filter": "滤镜",
    "notifications.rp_has_been_returned": "金奖团体生活科目已经被修改",
    "pageTitle.residetial_project_assessor_report": "金奖团体生活科目－评审员报告",
    "label.generating": "生成中",
    "moduleTitle.finance_system_data": "财务系统数据",
    "notifications.adventurous_journey_state_has_been_changed": "户外探索旅行状态已经修改。",
    "route.levels": "级别",
    "moduleTitle.activity_leader": "活动管理员",
    "tasks.approve_event": "批准活动",
    "tasks.reject_event": "拒绝活动",
    "table.region": "地区",
    "pageTitle.nao_award_leaders": "国家办公室－奖项项目管理员",
    "errors.must_be_at_least": "最少{min}字符",
    "table.title": "名称",
    "table.last_activity": "最后的活动",
    "tasks.delete_registration": "删除注册",
    "table.date_time": "当地时间",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "爱丁堡公爵国际奖运营者承诺尊重您的隐私。此表收集的个人信息的目的是参加奖项活动。参与者如未能提供此表格信息，则无法参加奖项活动。（此项不适用于非规定的参与者数据）我们也许会发送一些您感兴趣的其他奖项活动信息至您提供的联系方式中。我们也可能会向国际组织或者服务商提供您的信息，以此帮助奖项运营与管理。如果您希望联系我们或者获取您个人信息，请联系奖项运营者。你也可以联系运营者，要求一份隐私保护政策。",
    "aj.practice_journey": "实践旅程",
    "notification.log_has_been_restored": "活动日志已经被保存",
    "tabs.my_participants": "我的参与者",
    "label.bulk_action_assign_label": "分配标签",
    "moduleTitle.supervisor": "监督员",
    "moduleTitle.your_parental_consent": "您的父母同意书",
    "route.registration_participants": "注册的参与者",
    "placeholder.start_typing": "开始打字",
    "tasks.approve_award": "批准奖项",
    "route.registrations": "注册",
    "button.add_activity": "添加活动",
    "notifications.aj_event_has_been_created": "户外探索旅行活动已经创建。",
    "states.supervisor_approval": "审核员同意",
    "label.description": "描述",
    "button.leave_anyway": "离开",
    "tabs.registrations": "注册",
    "states.leader_signoff": "科目授权",
    "moduleTitle.forbidden": "禁止",
    "notifications.translations_has_been_updated.button": "通知. 翻译已经得到更新",
    "pageTitle.nao_registration": "国家办公室－注册",
    "pageTitle.mro_logs": "我的地区办公室－日志",
    "meta.page_not_found": "未发现页",
    "label.bulk_action_unsuccessful": "{     }个项目失败：",
    "global.days": "日子",
    "table.review": "检验",
    "table.as_assessor_for": "成为审核员",
    "roles.if_staff_statistical_user": "爱丁堡公爵国际奖基金会数据使用者",
    "table.levels": "级别",
    "label.suitable_for_level": "适合级别",
    "pageTitle.leaders": "奖项导师",
    "moduleTitle.send_test_email": "发送测试邮件",
    "pageTitle.tasks_removed_registration": "删除参与者注册",
    "label.you_will_be_forced_to_login_again_after_change": "修改完成后你会被要求再次登陆",
    "table.recent_updates": "最近更新",
    "pageTitle.tasks_activity_signoffs": "科目签字",
    "pageTitle.payments": "支付",
    "global.nights": "晚上",
    "label.blank_any_level": "任一级别的空缺",
    "button.view_section": "查看科目",
    "moduleTitle.select_organization": "选择组织",
    "pageTitle.manual_data_import": "手动数据导入",
    "button.upload_files": "上传文件",
    "label.migrated_contact_email": "迁移联系人的邮箱地址",
    "label.for_award_unit": "为奖项中心",
    "label.aj_template_note": "备注模板",
    "table.last_log_added": "最后添加记录",
    "button.view_participant": "来于参与者",
    "label.please_comment_on_the_participants": "请评论参与者的进步/表现/承诺",
    "label.consent_already_given_login": "同意书已经提交。请用孩子姓名登陆",
    "participant.level_start_date": "{value} 开始日期",
    "sidebar.my_region_office": "我的地区办公室",
    "states.section_signoff": "科目签字",
    "moduleTitle.assessor_details": "审核员详情",
    "moduleTitle.adventurous_journey_settings": "户外探索旅行设置",
    "moduleTitle.note_from_al": "导师备注",
    "button.add_role": "增加角色",
    "table.run": "跑",
    "states.change_to_state_warning_missing_assessment": "提示：尚未添加评估。你还想继续吗？",
    "label.user_app_guide_leader": "应用程序操作指南-导师",
    "tabs.section_approval": "科目得到批准",
    "roles.award_verifier": "奖项确认",
    "tabs.activity_approval": "活动得到批准",
    "logs.add_log": "增加日志",
    "tabs.award": "奖项",
    "notifications.this_role_has_read_only_persmission": "此角色具有只读权限",
    "table.no_filtered_results": "无过滤后的结果",
    "button.praise": "备注",
    "label.prevent_welcome_email_assessor": "不给评估员发送欢迎邮件",
    "label.location_detail": "地址细节",
    "label.optional": "（仅供选择）",
    "errors.do_not_match": "不匹配",
    "label.use_comma_for_multiple_entries": "使用逗号表示多个条目",
    "label.operating_authority": "操作权限",
    "label.activity_section": "活动科目",
    "notifications.you_have_been_logged_out": "您已经退出",
    "table.finished": "完成",
    "button.same_as_billing": "等同",
    "table.payment": "付款",
    "table.current_level": "当前级别",
    "button.view_nao": "奖项办公室退回（附更改说明）",
    "table.email_confirmation": "邮箱确认",
    "moduleTitle.shipping_address": "邮递地址",
    "label.secondary_phone_type": "二级电话号码",
    "notifications.saved": "保存",
    "pageTitle.all_participants": "所有参与者",
    "label.first_name": "名",
    "label.oa_price": "运营机构价格",
    "table.award_mode": "奖项模式",
    "tabs.api_keys": "Api Keys",
    "award.award_detail": "奖项细节",
    "tabs.user_management": "使用者管理",
    "tabs.all_events": "所有的活动",
    "notifications.history_record_has_been_removed": "历史记录已经被删除",
    "award.no_data": "没有日期",
    "notifications.preparation_training_has_been_added": "准备与培训已经添加",
    "label.message": "信息",
    "notifications.participant_info_updated": "参与者信息已经得到更新",
    "roles.nao_staff": "爱丁堡公爵国际奖国家办公室职员",
    "tabs.adventurous_journeys": "户外探索",
    "label.gops": "全球运营伙伴",
    "route.upload": "上传",
    "notifications.history_record_has_been_added": "历史记录已经被添加",
    "notifications.history_record_has_been_updated": "历史记录已经被更新",
    "label.no_data": "没有数据",
    "button.add_coordinator": "增加协调员",
    "label.you_are_already_logged_as": "您已经登陆为",
    "route.my_national_office": "我的国家办公室",
    "tabs.leaders": "导师",
    "label.email_confirmation": "邮箱确认",
    "table.registration_date": "注册日期",
    "notifications.role_has_been_removed": "新的角色被删除。",
    "button.move": "移动",
    "label.terms_and_conditions": "条款",
    "pageTitle.detail": "细节详情",
    "table.award_unit": "奖项单位",
    "sidebar.settings": "设置",
    "dashboard.leader_state": "导师－按照省份",
    "notifications.award_unit_has_been_approved": "奖项单位已经被批准",
    "states.awaiting_approval": "等待批准",
    "table.level": "级别",
    "table.action_requested": "请求行动",
    "label.organisation_mode": "机构模式",
    "label.no_note": "没有备注",
    "tabs.my_events": "我的活动",
    "notifications.participants_have_been_added": "参与者已经被添加成功。",
    "tabs.registration_questions": "注册问题",
    "button.delete_registration": "删除注册",
    "notifications.parental_consent_link_has_been_sent": "父母同意书链接已经发送",
    "moduleTitle.select_role_organization": "选择角色或组织",
    "label.experience": "经验",
    "translationsManagement.modal.title": "translationsManagement.modal.title\n",
    "table.ic": "独立国家",
    "table.id": "身份证明",
    "label.notify_email_explanation": "参与者将收到电子邮件通知，他们的评估请求尚未送达，他将被要求更正电子邮箱并再次要求评估。",
    "participant.would_you_like_to_remove": "您希望删除这个帐号吗？",
    "table.fields_included": "包含区域",
    "label.user_guide_web_leader": "网站使用指南-导师",
    "label.journey_type": "旅行类别",
    "button.setup": "设置",
    "tabs.my_national_office": "我的国家办公室",
    "notifications.training_has_been_removed": "培训已经被删除。",
    "label.nominated_and_identified_persons": "提名指定可以查看数据但不能编辑的人",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "由于您不使用，现已经退出登陆",
    "states.award_leader_signoff": "导师签字",
    "table.award_signoff_attempts": "奖项签字尝试",
    "sidebar.regions": "地区",
    "label.activity_deleted_note": "活动已被删除。你可以点击下面的键重新存储",
    "table.total": "总共",
    "errors.a_problem_has_occured_during_processing": "处理过程中出现问题，请参阅更多信息",
    "participant.participant_already_has_gold_award": "参与者拥有金奖奖章",
    "pageTitle.mro": "我的地区办公室",
    "notifications.authorization_code_has_expired": "授权码已经失效",
    "moduleTitle.child_organization_labels": "学生机构标签",
    "aj.aj_events": "户外探索旅程事件",
    "global.loading": "登录中",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "注册",
    "label.any_string": "任何短语",
    "contact.change_contact_status": "修改联系人的状态",
    "tabs.registration": "注册",
    "label.override_payment_note": "覆盖付款单",
    "notifications.section_has_been_signed_off": "科目已经被签字。",
    "label.payment_date": "支付日期",
    "button.approve": "批准",
    "moduleTitle.loggin_in": "登陆",
    "label.website": "网站",
    "label.role": "角色",
    "table.assessor_report": "评审员报告",
    "label.ue_fe": "用户参与前端（参与者web静态标签）",
    "label.please_comment_on_the_participants_effort": "请评论参与者如何通过努力实现活动目标的",
    "label.previously_worked_as_assessor": "此前是奖项审核员",
    "pageTitle.registrations": "注册",
    "parentalConsent.this_form_must_be_completed": "18岁以下的参与者的家长或监护人必须完成此表格。",
    "button.apply": "适用",
    "errors.include_at_least_one_number": "包括至少一个数字",
    "label.content_restore": "刷新会议",
    "logs.hour": "小时",
    "parentalConsent.i_have_read_and_understand": "7. 我已经阅读并理解奖项的不同级别及要求",
    "notifications.award_was_deleted": "奖项已删除",
    "label.journey_category": "旅行分类",
    "notifications.search_cancelled": "搜索被中断，您需要等待搜索完成。",
    "route.detail": "详情",
    "route.user_guide": "使用指南",
    "moduleTitle.history": "历史",
    "table.gop_name": "全球运营伙伴",
    "pageTitle.tasks_unassigned_participants": "未指派参与者",
    "states.inactive": "无效",
    "pageTitle.search_results": "搜寻结果",
    "button.proceed_to_login": "开始登陆",
    "pageTitle.assessor_report_reject": "评审员报告返回",
    "notifications.contact_has_been_removed": "联系方式已删除。",
    "sidebar.operating_authorities": "操作权威机构",
    "label.no_note_from_participant": "没有来自于参与者的备注",
    "aj.preparation_and_training": "准备与培训",
    "route.user_guide_web_leader": "网站使用指南-导师",
    "label.position_in_organization": "组织中的职位",
    "errors.emails_dont_match": "邮箱不一致",
    "route.my_participants": "我的参与者",
    "pageTitle.customisations": "定制服务",
    "tabs.localization_files": "本地化文件",
    "table.assessor_approval": "评审员批准",
    "tabs.related_contacts": "相关联系",
    "table.aus": "奖项单位",
    "table.category": "分类",
    "errors.file_is_too_large": "最大上传20MB",
    "label.possible_values": "可能的价值",
    "label.if_your_download_doesnt_start": "如果您的自动下载没有成功，可以点击此处",
    "route.independent_award_centres": "独立奖项运营中心",
    "pageTitle.user_guide": "使用指南",
    "button.visit": "访问",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "我的机构-细节",
    "pageTitle.nao_detail": "国家办公室－详情",
    "button.change": "改变",
    "award.aj": "户外探索旅程",
    "table.award_state": "奖项状态",
    "pageTitle.tasks_award_signoff": "奖项签字",
    "pageTitle.regions": "地区",
    "notifications.award_has_been_signed_off": "奖项已经得到签字。",
    "dashboard.award_approved_by": "奖项得到批准－2016年按照级别",
    "tabs.new_template": "新的模板",
    "error.parent_email_must_be_filled": "必须填写父母邮箱地址",
    "label.organisation_invoicing_name": "机构发票名称",
    "pageTitle.related_contacts": "联系信息",
    "button.try_again": "关闭警告然后重新再试试",
    "label.cannot_be_change_to_another": "无法修改成另一个奖项级别",
    "notifications.lead_coordinator_has_been_set": "新的主要协调员已经设置",
    "label.training_name": "训练名字",
    "moduleTitle.new_contact": "新的联系人",
    "translationsManagement.modal.updateTitle": "translationsManagement.modal.updateTitle\n",
    "moduleTitle.offline_award_units_signoff": "线下奖项导师签字",
    "notifications.award_level_has_been_changed": "奖项级别已经被修改",
    "label.subject": "主题",
    "route.silver_level": "银奖",
    "label.privacy_notice": "隐私通知",
    "label.switch_organization": "更换组织",
    "meta.dofe_name": "爱丁堡公爵国际奖",
    "route.profile": "简况",
    "roles.super_user": "超级用户",
    "dashboard.while_you_were_gone": "您离开的期间",
    "label.no_note_from_award_leader": "奖项办公室退回（附更改说明）",
    "label.middle_name": "中间名",
    "moduleTitle.new_activity": "新的活动",
    "organisation.would_you_like_to_remove": "你希望删除这个机构吗？",
    "label.state_province": "州／省／地区",
    "moduleTitle.your_home_address": "您的家庭住址",
    "tabs.sign_offs": "签字",
    "moduleTitle.logs": "日志",
    "button.view_more": "查看更多",
    "label.profile": "简介",
    "label.title": "职务",
    "tabs.award_signoff": "奖项签字",
    "label.post_code": "邮编",
    "states.ceremony_certificate": "庆典与证书",
    "label.code": "运营方参考",
    "parentalConsent.i_consent_to_the_provision_of_any": "我同意将个人信息提供给奖项单位及奖项运营者。我同意我的信息按照相关奖项运营者的隐私政策（不断修改），1988年英国数据保护法中的国家隐私政策（或者任何一个同类型的国家法规法则），以及其他隐私立法，标准，指南或者隐私权立法来处理。",
    "label.user_guide_web_participant": "网站使用指南-参与者",
    "label.award_unit_type": "奖项单位类别",
    "states.complete": "完成",
    "table.participant_state": "参与者状态",
    "pageTitle.my_organization_payment": "我的机构-支付",
    "table.approved": "批准",
    "pageTitle.my_organization_contacts": "我的组织－联系",
    "warning.award_marked_as_paid_registration": "注意：此奖项注册标记为已支付。确认前请参考付款和退款指南。",
    "states.change_to_state": "改变状态",
    "label.integer": "整数",
    "notifications.translationUpdateInterrupted": "通知. 翻译更新被影响。",
    "notifications.password_has_been_changed": "密码已经被修改",
    "button.invite_assessor": "邀请审核员",
    "label.other_activity": "其他活动",
    "notifications.parental_consent_has_been_sent": "父母同意书已经被发送。",
    "button.revise": "修改",
    "errors.end_date_must_be_after_start_date": "结束日期必须后于开始日期",
    "label.award_leader_signoff_date": "奖项导师签字日期",
    "parentalConsent.i_understand_every_participant_must": "8. 我明白每一名参与者必须通过奖项单位来参加爱丁堡公爵国际奖，奖项单位有权接受或拒绝参与者，作为奖项的一部分，奖项单位可以建议参与者的活动内容。",
    "moduleTitle.policies": "政策",
    "pageTitle.tasks_aj": "户外探索活动",
    "global.day": "日",
    "moduleTitle.coordinator": "协调员",
    "label.region": "地区",
    "button.add_history_record": "增加历史纪录",
    "moduleTitle.adventurous_journey_template_settings": "户外探索旅行模板设置",
    "notifications.personal_details_have_been_updated": "个人信息已经更新",
    "sidebar.ics": "独立国家",
    "table.independent_award_centre": "独立运营中心",
    "label.undelivered_mail_reason": "未发送邮件原因",
    "table.utc_date_time": "UTC Time",
    "moduleTitle.emails": "邮箱",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "父母／监护人同意书",
    "label.photo_consent_given": "参与者同意我们使用她/他的照片宣传。",
    "moduleTitle.authorising_contact": "授权联系人",
    "label.assessment_with_role": "{角色}审核报告",
    "dashboard.type_of_awards": "奖项单位类别",
    "moduleTitle.payment": "付款",
    "states.in_progress": "进展中",
    "logs.no_logs": "无日志",
    "sidebar.my_office": "我的办公室",
    "label.assessor_report": "评审员报告",
    "notifications.rp_has_been_signed_off": "金奖团体生活科目已经签字",
    "tabs.labels": "标签",
    "sidebar.payments": "付款",
    "meta.profile_questions": "档案问题",
    "label.fax": "税",
    "label.email_help_custom_link": "自定义链接（如果已设置）",
    "label.last_name": "姓",
    "organisation.manage_gop": "管理全球运营伙伴",
    "table.parental_consent": "父母同意",
    "dashboard.participant_by_level": "参与者－按照级别",
    "tabs.award_leaders": "奖项导师",
    "label.i_confirm_that_ive_witnessed": "我确认我已经亲眼目睹了以下活动的参与者日志",
    "table.lead_coordinator": "主要联络员",
    "states.deleted": "删除",
    "label.no_answers": "没有答案",
    "button.add": "添加",
    "label.exchequer_number": "财务编号",
    "label.waiting": "等待",
    "label.email_help_person_full_name": "全名",
    "tasks.return_registration": "退回注册",
    "notifications.state_aj_preparation_training_has_been_changed": "户外探索准备和培训的状态已更改。",
    "label.parent_approval": "父母同意书",
    "table.assessor_approve": "评审员批准",
    "errors.some_fields_requires_your_attention": "一些地方需要您的注意",
    "aj.qualifying_journey": "资格旅程",
    "route.awards": "奖项",
    "table.registration": "注册",
    "pageTitle.assessors": "审核员",
    "notifications.award_has_been_updated": "奖项已经得到更新",
    "errors.must_be_one_of": "必须是其中",
    "pageTitle.logs": "日志",
    "notifications.notifications.invitation_has_been_sent": "邀请已经发送",
    "route.national_offices": "国家办公室",
    "notifications.training_has_been_updated": "培训已经上传",
    "label.parent_last_name": "父母／监护人姓",
    "table.leaders": "导师",
    "states.award_level_complete": "奖项级别完成",
    "button.reset": "重置",
    "sidebar.my_award_unit": "我的奖项单位",
    "pageTitle.all_aj_events": "所有的户外探索活动",
    "label.activity": "活动",
    "moduleTitle.are_you_sure": "您确定吗？",
    "route.gold_level": "金奖",
    "table.evidence": "证据",
    "label.delivery_confirmed": "奖项操作确认",
    "parentalConsent.as_the_parent": "作为父母／监护人，我同意爱丁堡公爵奖基金会用任何照片宣传使用。",
    "label.awardMode.offline": "线下",
    "tasks.approve_registration": "确认注册",
    "note.change_the_email_will_change": "备注：修改邮箱会修改迁移联系人的邮箱地址",
    "notifications.participant_has_been_approved": "参与者已经被批准",
    "label.reached_activity_limit": "此活动部分达到了活动限制。参与者每个部分最多可以有3个活动。",
    "label.facebook": "脸书",
    "notifications.label_has_been_removed": "标签已经更新",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "准备与培训已经被删除",
    "pageTitle.settings": "设置",
    "participant.level_registration_date": "注册日期",
    "notifications.question_has_been_removed": "问题已经被删除",
    "label.email_help_award_leader_full_name": "奖项导师全名",
    "sidebar.leaders": "项目管理员",
    "notifications.participants_have_been_transferred": "参与者已经被转移",
    "tabs.assessors": "审核员",
    "sidebar.dashboard": "仪表板",
    "pageTitle.independent_award_centers": "奖项独立运营中心",
    "label.search": "搜寻",
    "moduleTitle.office_labels": "办公室标签",
    "label.note_from_participant": "参与者备注",
    "errors.required_field": "必须字段",
    "tasks.approve_task": "批准任务",
    "logs.edit_log": "编辑日志",
    "table.state": "状态",
    "moduleTitle.level_summary": "级别概述",
    "moduleTitle.guides": "指导",
    "modal.close": "关闭",
    "label.parent_first_name": "父母／监护人名",
    "parentalConsent.i_understand_that_the_participant": "我理解奖项参与者参与奖项之前必须完成表格（包括父母／监护人同意书）并发回给相关奖项单位，缴费获得奖项单位认可。",
    "tabs.award_units": "奖项单位",
    "table.hours": "小时",
    "label.type": "类别",
    "notifications.adventurous_journey_has_been_removed": "户外探索旅行已经被删除",
    "label.aj_is_not_approved_yet": "户外探索活动未得到确认",
    "roles.authorizing_contact": "授权联系人",
    "table.date_submitted_to_office_signoff": "提交给奖项办公室签字的日期",
    "notifications.section_has_been_returned": "科目已经被退回。",
    "table.created_by": "创建",
    "route.user_guide_web_participant": "网站使用指南-参与者",
    "route.templates": "模板",
    "states.awaiting_sign_off": "奖项项目管理员签字",
    "table.phone": "电话",
    "label.parental_consent": "父母同意书",
    "label.org_contact_will_be_deleted": "您正在从此联系人中删除最后一个角色。您想保留个人数据还是完全删除联系人？",
    "route.bronze_level": "铜奖",
    "label.invoice_currency": "发票货币",
    "button.new_label": "新标签",
    "error.server_cannot_be_reached_at_the_moment": "当前无法连接服务器。请稍后再试。如果问题无法得到解决，请联系您的支持团队",
    "notifications.contact_has_been_created": "联系方式已创建。",
    "pageTitle.profile_questions": "简介问题",
    "table.observation_files": "活动心得文件",
    "table.participants": "参与者",
    "tasks.no_evidence": "无证据提供",
    "button.edit": "编辑",
    "moduleTitle.leader": "导师",
    "notifications.new_template_has_been_updated": "新的模板已经得到更新。",
    "table.name": "姓名",
    "label.no_results": "无结果",
    "moduleTitle.documents": "文件",
    "button.invite": "邀请",
    "label.goal": "目标",
    "pageTitle.nao_award_units": "国家办公室－奖项单位",
    "label.award_delete_participant_id": "参与者ID",
    "errors.at_least_num_characters": "至少字符长",
    "label.email_help_note": "自定义注释（如果已设置）",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "删除角色",
    "label.total": "总共",
    "label.delete_participant_award_info": "您将要删除奖项级别。这是不可逆转的。规则：\na） 参与者需要获得超过个奖项\nb） 如果您要删除的奖励级别需要重大活动，则会重置该活动\nc） 如果删除后仍有两个奖项，则主要活动将设置在较低的一个奖项上，只有在该奖项未处于授权/完成/仪式状态的情况下。",
    "route.leaders": "导师",
    "table.start_date": "开始日期",
    "moduleTitle.coordinators": "协调员",
    "button.create": "创建",
    "tabs.awards": "奖项",
    "parentalConsent.form_has_been_sent": "父母同意书已经发送。",
    "states.journey_approval": "旅行计划得到批准",
    "pageTitle.reports": "报告",
    "table.journey_type": "旅行类别",
    "label.yes": "是",
    "pageTitle.assessor_report": "评审员报告",
    "label.organization": "组织",
    "notifications.award_leader_has_been_updated": "导师已更新。",
    "moduleTitle.edit_role": "编辑角色",
    "table.journey_activity": "旅行活动",
    "label.location": "地点",
    "label.update_translations_error_item": "更新翻译失败，原因是：{language}，代码：{localeCode}，项目：{projectCode}",
    "pageTitle.adventurous_journeys": "户外探索活动",
    "global.assessor": "评审员",
    "moduleTitle.profile_questions": "简介问题",
    "activity.cannot_edit_activity_if_award_in_state": "目前无法编辑奖项活动",
    "moduleTitle.assessor_detail": "评审员详情",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. 我明白奖项单位接收参与者的报名后，参与者会得到在线手册记录的权限，在网上操作报名并记录活动。参与者阅读在线手册上的奖项要求与指南，开始奖项活动。我明白参与者提交金，银或者铜奖申请后，奖项单位有权限决定活动是否满足奖项要求。我明白奖项单位可能提供给参与者的保险很有限，无法全部满足和人投保的所有需求。购买以及持续持有有效保险是参与者以及参与者家长的责任。",
    "notifications.award_has_been_returned": "奖项被退回。",
    "label.code_of_conduct": "行为准则",
    "button.new_contact": "新的联系",
    "tabs.payments": "支付",
    "roles.naa_oa_staff": "奖项机构职员",
    "label.switch_organisation_hint": "您可以通过选择右上角菜单中的“切换组织”随时打开此对话框",
    "label.expiration_date": "失效日期",
    "tabs.participants": "参与者",
    "table.practice": "练习",
    "notifications.one_activity_has_to_remain": "一个科目的一个活动要保持活跃",
    "label.qualifications": "资质",
    "states.organization_approval": "组织批准",
    "errors.must_be_an_integer": "必须是整数",
    "participant.send_confirmation_email_again_question": "再次发送确认邮箱？",
    "button.dismiss": "拒绝受理",
    "table.advice": "建议",
    "label.years_of_working_experience": "工作年限",
    "notifications.search_failed": "调查后发现一个错误。请稍后重试",
    "notifications.changes_have_been_saved": "所有修改已经被保存",
    "moduleTitle.resend_parental_consent_link": "重新发送父母同意书链接",
    "label.activity_type": "活动类别",
    "label.change_award": "修改奖项级别",
    "label.email": "邮箱",
    "button.remove": "删除",
    "button.download": "下载",
    "label.vat_treatment": "增值税待遇",
    "pageTitle.aj_template_new": "新的户外探索活动模板",
    "table.per_page": "每页",
    "notifications.translations_has_been_updated": "通知.翻译已经得到更新\n",
    "notification.award_mode_has_been_updated": "奖项模式已经更新",
    "tasks.revise_item": "修改项目",
    "button.resend_parental_consent": "重新发送父母同意书",
    "table.weeks_completed_required": "要求/完成的周数",
    "label.last_modified": "最后修改",
    "table.major": "主要的活动",
    "label.vat_number": "增值税号",
    "errors.passwords_dont_match": "密码不一致",
    "table.country": "国家/地区",
    "sidebar.guides_and_policies": "指导和政策",
    "notifications.question_has_been_updated": "问题被更新",
    "table.participant_name": "参与者姓名",
    "label.registration_approval_date": "注册批准日期",
    "notifications.auth_code_is_no_longer_valid": "授权码不再有效",
    "errors.must_be_no_more_than": "最多不超过 {max} 字符",
    "notifications.event_has_been_rejected": "活动已经被退回。",
    "tabs.customizations": "自定义",
    "label.name_organization": "名字",
    "button.add_log": "添加日志",
    "moduleTitle.invite_assessor": "邀请审核员",
    "label.resend_confirmation_email": "重新发送确认邮件",
    "text.all_participants_will_be_transfered": "所有的参与者都被转移到一个新的奖项导师名下",
    "label.repeat_email": "重复邮箱",
    "errors.email_or_phone_required": "邮箱或者所需电话",
    "notifications.role_has_been_updated": "角色已经被更新",
    "roles.if_staff_stat_user": "基金会数据用户",
    "participant.delete_account": "删除帐户",
    "moduleTitle.would_you_like_to_remove_this_log": "您希望删除这个日至",
    "sidebar.sgops": "SGOPs",
    "label.prepare_new_email": "准备新邮件",
    "table.journey_category": "旅行分类",
    "sidebar.manual_data_import": "手动数据导入",
    "label.created_after_date": "创建之后",
    "route.my_organization": "我的组织",
    "button.show_list": "展示列别",
    "label.leaders": "导师",
    "notifications.log_has_been_modified": "日志已被修改",
    "button.upload_file": "上传文件",
    "moduleTitle.which_section_do_you_want_to": "哪个科目你希望返回到“进行中”？",
    "tabs.bronze_level": "铜奖级别",
    "notifications.participants_have_been_saved": "参与者已经被保存。",
    "pageTitle.aj_template_detail": "户外探索活动",
    "label.parent_email": "父母／监护人 邮箱",
    "map.appr_location": "类似地址",
    "notifications.log_has_been_removed": "日志已经被删除",
    "notifications.label_has_been_assigned": "标签已经指定",
    "pageTitle.tasks_undelivered_emails": "没有发送的邮件",
    "button.stay": "继续",
    "table.previous_level": "之前的级别",
    "label.award_start_date": "奖项开始日期",
    "assessor_report.returned_to_participant": "返回参与者",
    "pageTitle.tasks_assessors_registration": "审核员注册",
    "aj.cannot_modify_award": "参与者没有被指定到户外探索活动，无法修改奖项级别。",
    "moduleTitle.lost_internet_connection": "网络连接已断",
    "states.ceremony": "庆典",
    "participant.reactivate_account": "激活帐户",
    "label.birthdate": "出生日期",
    "pageTitle.assessment_send_successfully": "评估报告成功发送",
    "states.assessor_approval": "评审员批准",
    "award.change_award_level": "修改奖项级别",
    "label.url_no_longer_valid": "网址失效",
    "button.update": "更新",
    "label.secondary_email": "二级邮箱",
    "button.role_edit": "编辑",
    "table.award_leader": "奖项导师",
    "label.level": "级别",
    "tasks.evidence": "证据",
    "notifications.participant_is_already_in_list": "参与者已经在名单中",
    "button.clear": "清除",
    "label.allow_log_after_25_yoa": "25周岁之后允许添加内容",
    "states.setup": "设置",
    "table.activity": "活动",
    "label.copy_to_clipboard": "{text}已复制到剪贴板。",
    "route.award_units": "奖项单位",
    "button.upload_photo": "上传照片",
    "table.hours_completed_required": "完成的时间/要求的时间",
    "table.first_name": "名",
    "notifications.adventurous_journey_has_been_returned": "户外探索旅行已经被退回。",
    "pageTitle.national_offices": "国家办公室",
    "notifications.you_have_been_logged_in": "您已经登陆",
    "logs.offline": "线下",
    "moduleTitle.add_role": "添加角色",
    "label.user_app_guide_participant": "应用程序操作指南-参与者",
    "notifications.file_has_been_removed": "文件已经被删除",
    "label.send_message": "发送消息",
    "button.select": "选择",
    "label.reason_of_deletion": "删除的原因",
    "label.user_guide": "使用指南",
    "pageTitle.nao_participants": "国家办公室－参与者",
    "tabs.sub_operating_partners": "附属运营伙伴",
    "table.uploaded_by": "上传",
    "tasks.approve_item": "批准项目",
    "tasks.restore_participant_registration": "重储存参与者注册",
    "label.awardMode.hybrid": "混合",
    "table.first_activity_started": "第一个开始的活动",
    "moduleTitle.dates": "日期",
    "table.no_results": "无结果",
    "states.registration_approval": "注册批准",
    "table.breakdown_of_hours": "细分时间",
    "pageTitle.tasks_registration": "参与者注册",
    "button.create_new": "创建新的",
    "sidebar.todolist": "待做事项",
    "label.active_participants": "活跃参与者",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "退回任务",
    "organisation.change_organisation_state": "修改机构状态",
    "moduleTitle.roles": "角色",
    "label.no_config_key_available": "此部分没有可用的配置键",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "办公室签字",
    "notifications.translations_has_been_updated.failure": "通知. 翻译已经得到更新. 错误",
    "logs.minute": "分钟",
    "label.last_activity": "最后的活动",
    "sidebar.user_guide": "用户指南",
    "label.trained_award_leader": "接受过训练的导师",
    "table.progress": "进展",
    "table.suboperating_authorities": "子操作权威机构",
    "activity.cannot_edit_activity_offline": "此参与者正在离线模式下运行。如果奖励处于半离线模式，则科目活动，户外探索旅行或金奖团体生活科目等无法编辑。",
    "label.user_does_not_have_permissions": "用户没有权限阅读此内容。",
    "notifications.assessor_has_been_approved": "审核员已经被确认",
    "route.activity_approval": "活动批准",
    "moduleTitle.role": "角色",
    "button.run": "跑",
    "label.to": "到",
    "notifications.file_has_been_updated": "文件已经被上传",
    "moduleTitle.edit_coordinator": "编辑协调员",
    "notifications.authorization_code_is_no_longer_valid": "授权码不再有效",
    "button.reject": "拒绝",
    "label.label.participant_status": "参与者状态",
    "award.gold_level": "金奖级别",
    "sidebar.variables": "多样的",
    "parentalConsent.checkbox_copy": "我确认我是参与者的父母／监护人。我同意他／她参加奖项。我已经阅读，理解并统一奖项网站上所述的参与奖项的要求与条件。",
    "button.go_to_dashboard": "去仪表",
    "button.add_option": "增加选项",
    "label.is_completed": "完成",
    "pageTitle.award_units": "奖项单位",
    "states.completed": "完成",
    "button.adventurous_journey_template_settings": "户外探索旅行模板设置",
    "label.system_rights": "系统权利",
    "label.assessor_assesstment_award_start_date": "label.assessor_assesstment_award_start_date",
    "label.update_translation_question": "将更新选定项目所有现有语言的翻译。",
    "button.login": "登录",
    "label.name_of_the_unit": "奖项单位名字",
    "button.send": "发送",
    "award.ajs": "户外探索旅程",
    "meta.payments_expired": "支付-失效",
    "label.age": "年龄",
    "notifications.payment_info_updated": "支付信息已经被更新",
    "table.is_completed": "完成",
    "table.invited_by": "被邀请",
    "route.files": "文件",
    "route.assessors": "审核员",
    "info.aj_supervisor_is_mandatory": "对于练习旅行，奖项监督员将收到评估请求，对于资格旅行，评估员将收到评估请求",
    "pageTitle.my_participants": "我的参与者",
    "label.change_leader_status": "修改导师状态",
    "moduleTitle.parent_consent_form": "父母／监护人同意书",
    "notifications.authorization_contact_has_been_set": "授权联系人已设置。",
    "button.close": "关闭",
    "label.independent_country": "独立国家",
    "notifications.aj_preparation_training_has_been_returned": "户外探索旅行准备与培训已经被修改",
    "route.history_log": "历史日志",
    "participant.account_settings": "帐户设置",
    "label.bulk_action_error_item": "{  全球   }{   名  }{   姓  }{  电子邮箱   }因为",
    "label.orb_account": "ORB账户",
    "notifications.file_url_is_not_specified_in_configuration": "未在配置中指定文件URL",
    "notifications.award_unit_has_been_removed": "奖项机构/独立运营中心已经被删除",
    "table.parent": "父母",
    "label.mode_of_transport": "交通方式",
    "label.parental_consent_email_info": "不要忘记从父母邮件中点击确认，发送同意书。",
    "label.current_award": "当前奖项",
    "table.action": "行动",
    "pageTitle.suboperating_authorities": "子操作权威机构",
    "notifications.award_leader_has_been_assigned": "导师已经指定",
    "tabs.sign_offs_locally": "当地签字",
    "Activity log has been restored": "通知-日志-已经被重新存储",
    "sidebar.naos": "爱丁堡公爵国际奖授权国家办公室",
    "tabs.aj_templates": "户外探索活动模板",
    "notifications.logging_out": "退出",
    "label.update_label": "更新的标签",
    "button.organisation_settings": "机构设置",
    "tabs.independent_award_centers": "独立运营中心",
    "label.current": "当前",
    "table.location": "位置",
    "button.search": "搜索",
    "notifications.aj_preparation_training_has_been_approved": "户外探索旅行准备与培训已经被批准",
    "route.participants": "参与者",
    "label.other_location_information": "其他地点信息",
    "label.number_of_records": "记录数",
    "translationsManagement.infoLabel": "translationsManagement.infoLabel\n",
    "parentalConsent.i_consent_to_pay_all": "5. 我知道，参与奖项活动，则同意支付在参与奖项过程中出现的任何事故伤害，疾病或者其他情况造成的费用。",
    "label.nationality": "国籍",
    "states.approval": "批准",
    "notifications.something_went_wrong": "出问题了",
    "aj.practice": "实践",
    "label.addressLine2": "地址第二行",
    "label.please_leave_a_note": "请留言",
    "placeholder.select": "选择",
    "label.observations": "观察",
    "label.aim": "目标",
    "label.addressLine1": "地址第一行",
    "roles.aj_instructor": "户外探索活动讲师",
    "meta.payments_waiting": "支付-等待",
    "label.award_to_delete": "删除奖项级别",
    "label.category": "分类",
    "roles.instructor": "讲解员",
    "moduleTitle.remove_customization_and_reset": "删除自定义并重置配置值？",
    "notifications.participant_registration_has_been_restored": "参与者注册已经重新保存",
    "organisation.change_award_unit_mode": "修改机构模式",
    "table.organization_type": "机构类别",
    "notifications.participant_has_been_deleted": "参与者已经被删除",
    "label.language_settings": "语言设置",
    "notifications.event_has_been_approved": "活动已经得到批准。",
    "label.password": "密码",
    "label.text": "文章",
    "table.observations": "活动心得",
    "notifications.participant_has_been_created": "参与者已经被创建",
    "table.note_for_al": "导师备注",
    "label.payment_confirmed": "支付确认",
    "label.previous_completed_award_level": "之前的级别",
    "pageTitle.new_aj_event": "新的户外探索活动",
    "label.backend": " label.backend",
    "label.relationship_to_participant": "与参与者的关系",
    "award.physical_recreation": "体能锻炼",
    "contact.collect_emails": "收集邮件邮箱地址",
    "moduleTitle.assessor_report_reject": "审核员报告退回",
    "label.supervisor_report": "监督者报告",
    "table.role": "角色",
    "route.user_guide_web_nao": "网站使用指南-国家级奖项办公室",
    "label.page_not_found": "404-网页没有找到",
    "table.labels": "标签",
    "notifications.file_has_been_uploaded": "文件已经被上传",
    "moduleTitle.address": "地址",
    "moduleTitle.lead_coordinator": "主要协调员",
    "pageTitle.login": "登录",
    "label.frontoffice": " label.frontoffice",
    "participant.would_you_like_to_remove_registration": "你想要删除注册吗？",
    "notifications.rp_has_been_setup": "金奖团体生活项目已建立",
    "moduleTitle.award_unit": "奖项单位",
    "button.remove_file": "删除文件",
    "moduleTitle.billing_address": "帐单地址",
    "pageTitle.my_aj_events": "我的户外探索活动",
    "route.tasks": "任务",
    "button.confirm": "确认",
    "label.national_award_authority": "国家奖项权威机构",
    "label.independent_award_centre": "爱丁堡公爵国际奖独立运营中心",
    "award.generate_award_report": "生成报告",
    "route.my_region_office_customization": "我的地区办公室-定制",
    "label.email_help_aj_category": "户外探索类别",
    "label.your_report_has_been_rejected": "您已拒绝评估",
    "notifications.password_change_request_has_been_sent": "密码修改要求已经被发送。",
    "tabs.detail": "详情",
    "participant.change_participant_status": "改变参与者状态",
    "table.key": "键",
    "label.find_address": "找到地址",
    "notifications.assessor_has_been_rejected": "审核员已经修订",
    "label.transfer_participants": "转移参与者",
    "button.continue_to_payment_gateway": "继续支付到网关",
    "notifications.participant_registration_has_been_removed": "参与者注册已经被删除",
    "moduleTitle.page_not_found": "404 网页找不到",
    "route.adventurous_journeys": "户外探索旅行",
    "states.registration_assessment": "注册评估",
    "heading.change_award_unit_mode": "修改奖项单位模式",
    "label.user_guide_web_nao": "网站使用指南-国家级办公室",
    "tabs.silver_level": "银奖级别",
    "table.paid_by": "已经支付",
    "label.your_report_has_been_successfully_sent": "你的报告已经成功提交",
    "sidebar.my_organization": "我的组织",
    "pageTitle.participants": "参与者",
    "notifications.preparation_training_has_been_updated": "准备于培训已经更新",
    "moduleTitle.server_is_unreachable": "服务器无法连接",
    "label.last_activity_date": "最后活动时间",
    "award.bronze_level": "铜奖级别",
    "moduleTitle.award_units": "奖项机构",
    "table.completed": "完成",
    "moduleTitle.revise_message": "修改信息",
    "table.lastUsed": "最后使用",
    "award.bronze_to_gold_level": "铜奖至金奖级别",
    "button.change_password": "修改密码",
    "label.nao_price": "国家办公室价格",
    "label.payment_state": "付款状态",
    "label.wwc_expired": "WWC 过期",
    "label.award_office_signoff_date": "奖项办公室签字日期",
    "label.award_unit": "奖项单位",
    "award.gold_level_short": "金奖",
    "moduleTitle.other_info": "其他信息",
    "table.note": "备注",
    "label.search_by_email_first_or_last": "通过邮箱，姓或名搜索",
    "tabs.history": "历史",
    "notifications.label_has_been_created": "标签已创建",
    "tabs.unassigned_participants": "未分配参与者",
    "table.main_award_leader": "项目协调员",
    "parentalConsent.i_as_the_parent": "本人明白参与爱丁堡公爵国际奖活动，某一些活动可能存在高风险以及有些风险可能并不在保险计划之内。我明白参与者有责任排除风险，选择最合适的活动来完成奖项。参与该奖项所产生的一切风险由参与者承担。",
    "label.state": "状态",
    "notifications.award_leader_has_been_removed": "奖项导师已经被删除",
    "tabs.organization_detail": "组织详情",
    "table.operating_authorities": "操作权威机构",
    "label.available_labels": "可用标签",
    "modal.select": "选择",
    "tabs.expired_payments": "无效支付",
    "moduleTitle.note_for_al": "导师备注",
    "moduleTitle.confirm": "确认",
    "notification.new_activity_added": "新的活动已经添加",
    "notifications.award_leader_has_been_moved": "导师已经改动",
    "label.award_mode": "奖项模式",
    "label.phone": "电话",
    "notifications.organization_has_been_updated": "组织已经更新",
    "moduleTitle.assessor": "评审员",
    "label.bulk_action_confirmation": "批量动作确认",
    "table.parent_approval": "父母批准",
    "label.date_of_delivery": "操作奖项日期",
    "sidebar.assessors": "审核员",
    "label.journey_activity": "旅行活动",
    "award.inactive_award": "未激活奖项",
    "label.end_date": "结束日期",
    "label.orb_testing": "ORB测试",
    "label.no_activities": "没有活动",
    "moduleTitle.please_confirm": "请确认",
    "button.login_with_another_account": "使用不同账号登录",
    "tasks.reject_registration": "拒绝注册",
    "label.submitted_after_date": "提交之后",
    "label.update_translations_successful": "{count}项已成功修改。",
    "button.assign_leader": "分配奖项导师",
    "table.already_running": "已经开展",
    "label.no": "不是",
    "label.count_items_selected": "{     }项目已选择",
    "label.secondary_phone_number": "二级电话号码",
    "label.my_experience": "我的经验",
    "notifications.adventurous_journey_has_been_approved": "户外探索旅行已经被批准。",
    "pageTitle.mro_detail": "我的地区办公室－详情",
    "moduleTitle.nao_specific_info": "授权国家办公室具体信息",
    "label.preparing_document_for_import": "准备文件要导入的文件",
    "tasks.observations": "观察所得",
    "notifications.confirmation_email_has_been_sent": "确认邮件已经发送",
    "button.restore": "重新存储",
    "label.importing_file": "文件导入中",
    "label.or_dont_agree": "或者不同意？ 你能",
    "moduleTitle.award_leader": "项目管理员",
    "label.me": "（我）",
    "tabs.sub_global_operating_partners": "全球运营伙伴",
    "button.export_table": "输出表格",
    "organisation.move_award_unit": "移动奖项机构",
    "label.file_category": "标签文件-分类",
    "notifications.connecting_to_server": "连接服务器",
    "parentalConsent.i_understand_that_a_and_b": "我明白参与者在开展爱丁堡公爵国际奖相关活动时，不可以驾驶机动车辆或者为其他参与者驾驶，除非参与者有合适有效的驾照且第三方保险到位承担由驾驶导致的受伤后果。同时参与者不可以搭乘任何未参与或协助爱丁堡公爵国际奖活动的人驾驶的车辆，除非驾驶者拥有合适有效驾照且有第三方保险承保任何由于驾驶导致的参与者受伤后果。",
    "table.reason": "原因",
    "pageTitle.contacts": "联系",
    "states.award_leader_approval": "导师批准",
    "meta.payments": "支付",
    "label.suboperating_authority": "子操作权限",
    "route.my_region_office": "我的地区办公室",
    "states.registration_not_approved": "注册未得到批准",
    "label.direct_entrant": "直接参与",
    "tabs.all_participants": "所有的参与者",
    "tabs.payment": "付款",
    "label.email_help_activity_name": "活动名称",
    "title.update_report": "更新报告",
    "label.repeat_new_password": "重复新的密码",
    "label.other_roles": "ORB配置文件页面",
    "logs.hours": "小时",
    "notifications.spreadsheet_has_been_imported_successfully": "电子表格已经成功导入",
    "label.bulk_action_question": "完成{      }个项目的批量操作？",
    "moduleTitle.personal_details": "个人信息",
    "label.bulk_action_emailing": "选中的参与者的邮箱",
    "route.my_events": "我的活动",
    "button.delete_award": "删除奖项",
    "errors.include_both_lower_and_upper_case": "包括至少大小写字母各一个",
    "tabs.removed_participant_registrations": "删除参与者注册",
    "sidebar.mynao": "我的爱丁堡公爵国际奖国家办公室",
    "tabs.office_details": "办公室详情",
    "label.major": "主要的",
    "tabs.documents": "文件",
    "label.new_password": "新的密码",
    "sidebar.adventure_journey": "户外探索旅行",
    "pageTitle.customizations": "自定义",
    "moduleTitle.assessor_report": "{role} 报告",
    "label.registration_date": "注册日期",
    "notifications.training_has_been_added": "培训已经被添加",
    "aj.qualifying": "资格",
    "moduleTitle.you_have_been_logged_out_session_terminated": "您已注销，因为会话已被终止",
    "award.service": "服务",
    "notifications.rp_state_has_been_changed": "金奖团体生活项目状态已改变。",
    "label.ctest_access": "测试站点访问",
    "table.created": "创建",
    "tasks.revise_task": "修改任务",
    "button.assign": "分配",
    "button.return": "退回",
    "table.status": "状态",
    "button.restore_activity": "重新存储活动",
    "tabs.new_aj_event": "新的户外探索活动",
    "roles.if_staff_viewer": "爱丁堡公爵国际奖员工查看者",
    "notifications.new_template_has_been_created": "新的模板已经创建成功。",
    "global.something_went_wrong": "有错误",
    "table.expire_day": "失效日期",
    "tabs.history_log": "历史纪录",
    "label.form_of_payment": "付款表格",
    "button.add_training": "增加培训",
    "label.par_reg_cust_note": "此选项卡允许您自定义参与者注册中显示的字段，并影响您收集的数据量。如果您希望进行更改，请联系您的地区办事处 - 只有爱丁堡公爵国际奖基金会系统管理员有权进行这些更改。",
    "label.my_qualification": "我的资质",
    "button.add_new_profile_question": "增加新的档案问题",
    "table.operating_authority": "运营机构",
    "table.aim": "目的",
    "table.awards": "奖项",
    "participant.deactivate_account": "关闭帐户",
    "table.organization_name": "机构",
    "label.email_help_award_leader_first_name": "奖项导师名",
    "table.date": "日期",
    "tasks.would_you_like_to_delete": "您希望删除这个参与者吗？",
    "notifications.configuration_value_has_been_updated": "配备值",
    "ajTemplates.fill_from_template": "填写模块",
    "contact.send_test_email": "发送测试邮件",
    "moduleTitle.aj_preparation_and_training": "户外探索旅程的准备与培训",
    "label.ce_be": "可定制邮件（邮件翻译）",
    "button.notify_participant": "返回至参与者",
    "label.parent_phone": "父母／监护人 电话号码",
    "label.nao_regulations": "NAO 规则",
    "award.skills": "技能",
    "label.reject_application": "拒绝这个申请",
    "leader.delete_account": "删除联系人",
    "table.assign": "分配",
    "roles.aj_supervisor": "户外探索旅行科目监督员",
    "label.logout": "退出系统",
    "moduleTitle.award_leader_edit": "编辑奖项导师",
    "moduleTitle.training": "培训",
    "notifications.coordinator_has_been_removed": "协调员已经被删除",
    "tabs.operating_partners": "运营伙伴",
    "moduleTitle.main_award_leader": "项目协调员",
    "label.bulk_action_successful": "{     }个项目已修改成功。",
    "tasks.clear_email_revision": "清除邮件更改",
    "table.preparation": "准备",
    "table.delete": "删除",
    "label.safeguarding_policy": "奖项基金会安保政策",
    "sidebar.reports": "报告",
    "pageTitle.sub_global_operating_partners": "全球运营合作伙伴",
    "label.is_major_activity_confirmation": "参与者已经选择了不同级别的主要科目。想再加一个吗？",
    "pageTitle.operating_authorities": "操作权威机构",
    "label.delete_participant_award_modal_question_detail": "你确实要删除参与者{参与者ID}的{奖项级别}吗。",
    "label.confirmed": "确认",
    "notifications.invitation_has_been_sent": "邀请已发送。",
    "pageTitle.independent_countries": "独立国家",
    "label.assessors_email": "审核员的邮箱",
    "tasks.approve_assessor_registration": "确认审核员注册",
    "table.award_duration": "奖项时长",
    "notifications.organization_has_been_moved": "机构已经被移走",
    "pageTitle.nao_payment": "国家办公室－付款",
    "participant.history_log": "历史纪录",
    "label.rejected_with_note": "退回信息",
    "label.already_running": "已经开始运营",
    "button.continue": "点击.继续",
    "award.no_data_to_show": "没有日期显示",
    "participant.send_email_invitation_again_question": "再次发送邮箱邀请",
    "label.reason_for_changing_assessor": "更换审核员的原因",
    "button.delete": "删除",
    "moduleTitle.requirements_and_conditions": "要求与条件",
    "roles.leader": "项目管理员",
    "label.if_download_doesnt": "如果下载没有自动开始，请检查浏览器中的弹出设置",
    "dashboard.your_todo_list": "您的待办事项",
    "notifications.award_unit_has_been_returned": "奖项单位已被修改",
    "moduleTitle.participant_activities": "参与者的活动",
    "errors.qualification_or_experience_required": "需要的资质或经验",
    "label.active_leaders": "活跃项目管理员",
    "aj.preparation": "准备",
    "button.change_state": "修改状态",
    "label.current_password": "当前密码",
    "pageTitle.global_operating_partners": "页标题。全球-运营-伙伴",
    "moduleTitle.contact_settings": "联系设置",
    "button.remove_photo": "删掉照片",
    "notifications.activity_has_been_setup": "活动已经建立",
    "errors.must_be_more_than": "必须超过",
    "table.goal": "目标",
    "notifications.coordinator_has_been_set": "已设置协调员",
    "label.cc": "抄送",
    "label.duration": "时长",
    "table.actions": "操作",
    "participant.send_email_invitation_again": "再次发送邮箱邀请",
    "moduleTitle.would_you_like_to_remove_participant": "您希望删除参与者吗？",
    "parentalConsent.i_authorise_employees": "我同意员工，官员，奖项单位或者其他任何参与组织奖项的个人，在参与者参加活动，旅途中及其他与奖项相关的活动中受伤，生病等情况下，获取必要的医疗救助或治疗，包括但不仅限于来自医生，护士，或者酒店住宿的帮助。",
    "button.reload_page": "重新登陆网页",
    "moduleTitle.update_translations": "更新项目翻译",
    "label.report_description": "包含的字段和更新，当前仅提供英文版。我们正在寻找解决方案，提供其他语言。",
    "table.email": "邮箱",
    "label.new_goal": "新的目标",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "无效邮箱地址",
    "pageTitle.new_contact": "新的联系",
    "sidebar.gops": "GOPs",
    "button.manage_participants": "参与者管理",
    "errors.invalid_phone_format": "无效电话号码",
    "notifications.login_details_have_been_changed": "登陆细节已经修改。",
    "moduleTitle.participant_logs": "参与者的日志",
    "label.save": "保存",
    "label.frequently_asked_questions": "常见问题",
    "label.city": "城市",
    "notifications.configuration_value_has_been_reset": "配置值已重置",
    "states.office_sign_off": "奖项办公室签字",
    "button.save": "保存",
    "button.import_data_from_selected_file": "从所选文件中导入数据",
    "parentalConsent.i_understand_that_the_participant_cannot": "我明白在任何参与者在开始奖项之前，他们指定的志愿者必须要满足我的要求。参与者指定的志愿者如果不是本单位职员，必须要具备适当的经验，满足奖项科目监督员或评审员的要求。任何相关志愿者必须完成并提交奖项单位要求的表格。",
    "pageTitle.apiKeys": "Api Keys",
    "label.international_region": "国际地区",
    "tabs.levels": "级别",
    "tabs.additional_files": "其它文件",
    "label.continuation_level": "持续参与级别",
    "table.adventurous_journey_detail": "户外探索旅行细节",
    "button.set": "设置",
    "label.i_certify_that_as_the_assessor": "我确认作为此项活动的{role} 该参与者已经满足所有要求。",
    "table.coordinator": "协调员",
    "participant.send_confirmation_email_again": "再次发送确认邮箱？",
    "table.report": "报告",
    "label.update_translations_results": "更新翻译结果",
    "table.observation_note": "活动心得备注",
    "label.view_more": "查看更多",
    "notifications.payment_link_has_been_reset": "支付链接已经重置",
    "table.type": "类别",
    "moduleTitle.updateConfigurationKey": "配置密匙更新",
    "sidebar.independent_award_centers": "奖项独立运营中心",
    "table.activity_type": "活动类别",
    "label.awardMode.online": "线上",
    "table.data_state": "最后刷新日期",
    "button.generate_report": "生成报告",
    "moduleTitle.assessed_by_award_leader": "导师评审",
    "table.child_protection_number": "儿童保护数",
    "button.bulk_change": "批量修改",
    "label.send_welcome_email": "发送欢迎邮件",
    "label.award_state": "奖项状况",
    "moduleTitle.overview": "概述",
    "table.aj_detail": "户外探索旅行详情",
    "pageTitle.tasks_activity_approvals": "活动批准",
    "label.section": "科目",
    "route.history": "历史",
    "route.event_participants": "活动参与者",
    "participant.account_detail": "帐号设置",
    "route.dashboard": "仪表板",
    "table.payments": "支付",
    "pageTitle.profile": "简介",
    "organisation.remove_organisation": "删除机构",
    "pageTitle.my_organization": "我的组织",
    "label.award_leader": "奖项导师",
    "notifications.assessor_has_been_updated": "审核员已经被更新",
    "label.participant_personal_reflection": "参与者个人反思",
    "button.add_key": "增加键",
    "header.appMotto": "公爵",
    "table.qualifying": "资格",
    "button.upload": "上传",
    "button.resend": "重新发送",
    "label.filename": "文件名",
    "label.change_parental_consent": "更改父母意见",
    "button.cancel": "取消",
    "label.aply_to_all_langs": "适用语言",
    "route.customization": "定制",
    "errors.minimal_duration_is": "最少时间长度必须是30分钟",
    "label.email_help_participant_first_name": "参与者名",
    "label.participant_status": "参与者状态",
    "award.bronze_level_short": "铜奖",
    "label.phone_type": "电话类别",
    "global.night": "晚上",
    "button.adventurous_journey_settings": "户外探索旅行设置",
    "participant.leader_must_be_selected": "必须选择导师",
    "pageTitle.translationsManagement": "翻译管理",
    "moduleTitle.user_added_preparation_and_training": "用户增加准备活动与培训",
    "table.approve": "批准",
    "label.role_in_organisation": "组织中的角色",
    "states.finished": "完成",
    "label.created": "创建",
    "button.back_to_home": "返回",
    "label.options": "选择",
    "contact.next_level_invitation": "下一个级别奖项的邀请",
    "moduleTitle.activity_detail": "活动详情",
    "route.section_signoff": "科目签字",
    "moduleTitle.assign_labels_bulk": "将所选标签分配给 ${项目计数} 参与者。",
    "button.contact_settings": "联系设置",
    "label.transation_id": "交易帐户",
    "notifications.activity_has_been_updated": "活动已经得到更新",
    "sidebar.awards": "奖项",
    "parentalConsent.images_consent": "作为家长／监护人，我同意爱丁堡公爵奖基金会使用任何照片用作宣传。",
    "participant.would_you_like_to_delete": "您希望删除这个帐号吗？",
    "roles.user": "用户",
    "label.label": "标签",
    "label.select_sheet": "从计算机中选择工作表",
    "global.no_results": "无结果",
    "moduleTitle.address_line_2": "地址第二行",
    "states.awaiting_office_sign_off": "等待奖项办公室签字",
    "moduleTitle.export": "出口",
    "moduleTitle.address_line_1": "地址第一行",
    "notifications.participant_has_been_assigned": "参与者已经被分配",
    "roles.viewer": "观察者",
    "label.participants_total": "参与者总数",
    "errors.auth_code_is_no_longer_valid": "授权代码不再有效 - 它可能已被使用或已过期",
    "label.file_is_not_available": "文件不可用",
    "button.select_template": "选择模板",
    "label.payment": "支付",
    "award.silver_level_short": "银奖",
    "table.participant_id": "参与者编号",
    "text.hours_old": "小时",
    "moduleTitle.your_personal_information": "您个人信息",
    "aj.minimum_date_recommendation": "练习户外探索旅行的最少建议日期及{name}为",
    "label.date_of_payment": "付款日期",
    "button.view": "观看",
    "label.create_new_label": "创建新标签",
    "title.confirmation": "确认",
    "button.set_participants": "参与者设置",
    "roles.assessor": "评审员",
    "moduleTitle.coordinator_settings": "协调员设置",
    "label.parent_relationship": "父母关系",
    "table.nao": "爱丁堡公爵国际奖国家办公室",
    "notifications.email_has_been_sent": "邮箱已经发送",
    "label.email_help_participant_full_name": "参与者全名",
    "sidebar.suboperating_authorities": "子操作权威机构",
    "route.award": "奖项",
    "label.no_roles": "没有角色",
    "table.files": "文件",
    "aj.minimum_date_requirements": "资格户外探索旅行的最少时间要求是",
    "pageTitle.labels": "标签",
    "label.participant_is_semi_offline": "参与者是线下的",
    "moduleTitle.other_coordinators": "其他协调员",
    "button.updateSelectedLanguage": "button.updateSelectedLanguage",
    "tasks.approve_award_registration": "批准奖项注册",
    "participant.invite_participant_to_next_level": "邀请参与者到下一个级别",
    "label.twitter": "推特",
    "pageTitle.awards": "奖项",
    "warning.award_marked_as_paid": "注意：至少有一个奖项级别或注册标记为已支付。确认前请参考付款和退款指南。",
    "table.edit": "编辑",
    "states.change_to_state_warning_missing_hours_to_complete": "提示：尚未记录所需的最短时长。你还想继续吗？",
    "label.dofe": "国际奖",
    "moduleTitle.after_assigning_a_role_to_yourself": "为自己分配或更改角色后，您需要再次登录。",
    "label.transaction_id": "转账身份证明",
    "table.suboperating_authority": "下属运营机构",
    "label.participant_survey": "作为一名奖项参与者，我很乐意参与基金会的在线调查",
    "label.created_by": "被创建",
    "button.send_confirmation_email_again_question": "再次发送确认邮箱",
    "label.email_help_award_leader_email": "奖项导师邮箱",
    "label.name": "姓名",
    "tabs.gold_level": "金奖级别",
    "pageTitle.award_documents": "奖项文件",
    "label.online_payments": "在线支付",
    "label.child_protection_number": "儿童保护数",
    "participant.send_password_recovery_email": "发送密码恢复邮件",
    "notifications.new_log_has_been_added": "新的日志已经添加。",
    "moduleTitle.add_gop_role": "添加GOP或者附属GOP的角色",
    "label.organization_name": "组织名字",
    "pageTitle.my_organization_templates": "我的组织－模板",
    "pageTitle.award_leaders": "项目管理员",
    "label.status": "状态",
    "label.street": "街道",
    "roles.if_staff_superuser": "爱丁堡公爵国际奖基金会员工超级用户",
    "table.licence_holder": "执照持有人",
    "label.created_at": "创建",
    "table.section": "科目",
    "table.system_rights": "系统权限",
    "label.iac_type": "独立运营中心类型",
    "label.other": "其他",
    "moduleTitle.login": "登陆",
    "label.no_data_to_show": "没有数据显示",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "一旦参与者指定到户外探索旅行，就无法再修改奖项级别。",
    "tabs.waiting_payments": "等待支付",
    "global.supervisor": "监督员",
    "notifications.new_role_has_been_added": "新的角色被添加。",
    "award.silver_level": "银奖级别",
    "heading.change_awards_mode": "修改奖项模式",
    "button.save_changes": "保存修改的信息",
    "organisation.would_you_like_to_move_award_unit": "你想把这个机构移动到哪里？",
    "label.fields": "标签区域",
    "label.email_help_organization_name": "奖项中心机构名称",
    "pageTitle.mro_related_detail": "我的地区办公室－详情",
    "table.started_at": "开始",
    "parentalConsent.i_consent_to_the_award_unit": "本人同意奖项单位及其他参加或协助组织奖项工作的个人，包括志愿者与司机，根据活动参与需求，按照要求安排参与者的旅行事宜。本人明白奖项单位会提前告知旅行的时间与地点。",
    "logs.minutes": "分钟",
    "label.total_participants": "总参与者",
    "moduleTitle.contact_info": "联系信息",
    "table.payment_link": "支付链接",
    "errors.please_contact_your_local_award_staff": "请联系奖项当地办公室"
}